import type { CollectionReference, DocumentData } from 'firebase/firestore'
import {
  collection,
  doc,
  serverTimestamp,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream, modelListStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { buildUnsupportedConverter } from '../shared/noops'
import type { FirestorePromptPostRoomStateType } from './schema'
import { schema } from './schema'
import { PromptPostRoomStateType } from '../../models/PromptPostRoomStateType'
import { type PostRoomStatePromptType } from './types'
import { updateDocWithError } from '../../firestore-mobx/fetch'

export * from './schema'

const unsupported =
  buildUnsupportedConverter<FirestorePromptPostRoomStateType>()

const readConverter: FirestoreDataConverter<FirestorePromptPostRoomStateType> =
  {
    toFirestore: unsupported.toFirestore,
    fromFirestore: (snapshot: QueryDocumentSnapshot) => {
      const data = snapshot.data({ serverTimestamps: 'estimate' })
      return schema.parse(data)
    },
  }

const getReadCollectionRef = (
  firestore: Firestore
): CollectionReference<FirestorePromptPostRoomStateType, DocumentData> => {
  return collection(
    firestore,
    'prompt',
    'post_room_state_prompt',
    'type'
  ).withConverter(readConverter)
}

export const getPromptPostRoomStateTypes = (repository: FirebaseRepository) => {
  const ref = getReadCollectionRef(repository.firestore)
  return modelListStream(repository, ref, PromptPostRoomStateType)
}

export const getPromptPostRoomStateType = (
  repository: FirebaseRepository,
  { type }: { type: PostRoomStatePromptType }
) => {
  const col = getReadCollectionRef(repository.firestore)
  const docRef = doc(col, type)
  return modelItemStream(repository, docRef, PromptPostRoomStateType)
}

export const updatePromptPostRoomStateType = async (
  repository: FirebaseRepository,
  {
    title,
    description,
    postRoomStateType,
  }: Pick<FirestorePromptPostRoomStateType, 'title' | 'description'> & {
    postRoomStateType: PostRoomStatePromptType
  }
) => {
  const ref = getReadCollectionRef(repository.firestore)
  const docRef = doc(ref, postRoomStateType).withConverter(null)
  return await updateDocWithError(
    docRef,
    {
      title,
      description,
      updatedAt: serverTimestamp(),
    },
    'UpdatePromptRubricTypeError'
  )
}
